import { createSlice } from "@reduxjs/toolkit";
import { toMemberContact } from "../functions/memberContact";

const initialState = {
    webSettings: {},
    sharedSettings: {},
    sharedSettingsLoaded: false,

    // Donor settings (donors only)
    donorUC: 'Member',
    donorsUC: 'Members',
    hasTestResults: false,
    // A boolean per feature, decided server-side. The client renders from it and never learns the
    // rule behind it - defaults to false, so a failed settings fetch shows less, not more.
    hasInfoTab: false,
    // DES-18590 Contact Us details the office typed on the Settings page; empty = logo only.
    memberContact: toMemberContact(null),

    // Loading states
    webSettingsLoaded: false,
    donorSettingsLoaded: false,
    settingsLoaded: false
}

const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {

        setWebSettings(state, action) {
            state.webSettings = action.payload;
            state.settingsLoaded = true;
        },
        setSharedSettings(state, action) {
            state.sharedSettings = action.payload;
            state.sharedSettingsLoaded = true;
        },    
        setDonorSettings(state, action) {
            state.donorUC = action.payload.Donor_UC || 'Member';
            state.donorsUC = action.payload.Donors_UC || 'Members';
            state.hasTestResults = action.payload.HasTestResults === true;
            state.hasInfoTab = action.payload.HasInfoTab === true;
            state.memberContact = toMemberContact(action.payload);
            state.donorSettingsLoaded = true
            state.settingsLoaded = state.webSettingsLoaded && state.donorSettingsLoaded
        },
        resetState: () => initialState,
    },
});

export const settingsActions = settingsSlice.actions;
export default settingsSlice;
